// =====================================================
// 📁 POSPriceFilterModal.tsx
// =====================================================

import { useEffect, useState } from 'react';

import FormModal from '../../../Modals/FormModal';
import POSInputField from '../../../POS/Fields/POSInputField';
import ActionButton from '../../../Buttons/ActionButton';

interface POSPriceFilterModalProps {
  isOpen: boolean;

  onClose: () => void;

  onConfirm: (price: number) => void;

  initialValue?: number;
}

const POSPriceFilterModal: React.FC<POSPriceFilterModalProps> = ({
  isOpen,

  onClose,

  onConfirm,

  initialValue = 0,
}) => {
  // =====================================================
  // 🔹 State
  // =====================================================

  const [price, setPrice] = useState(initialValue.toFixed(2));

  // =====================================================
  // 🔹 Sync
  // =====================================================

  useEffect(() => {
    setPrice(initialValue.toFixed(2));
  }, [initialValue]);

  // =====================================================
  // 🔹 Validation
  // =====================================================

  const parsedPrice = parseFloat(price);

  const isValidPrice = !isNaN(parsedPrice) && parsedPrice >= 0;

  // =====================================================
  // 🔹 Confirm
  // =====================================================

  const handleConfirm = () => {
    if (!isValidPrice) {
      return;
    }

    onConfirm(parsedPrice);

    onClose();
  };

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Precio máximo"
      maxWidth="max-w-md"
    >
      <div className="flex flex-col gap-5">
        {/* ===================================================== */}
        {/* 🔹 Description */}
        {/* ===================================================== */}

        <p
          className="
            text-sm
            text-body
          "
        >
          Define el precio máximo que se utilizará para filtrar los productos
          visibles en el catálogo.
        </p>

        {/* ===================================================== */}
        {/* 🔹 Field */}
        {/* ===================================================== */}

        <POSInputField
          label="Precio máximo"
          placeholder="0.00"
          icon="dollar"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          type="number"
        />

        {/* ===================================================== */}
        {/* 🔹 Actions */}
        {/* ===================================================== */}

        <div
          className="
            mt-2
            flex
            gap-2
          "
        >
          <ActionButton
            label="Cancelar"
            variant="secondary"
            onClick={onClose}
          />

          <ActionButton
            label="Aplicar"
            variant="primary"
            disabled={!isValidPrice}
            onClick={handleConfirm}
          />
        </div>
      </div>
    </FormModal>
  );
};

export default POSPriceFilterModal;
